<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              v-model="form.filters.pergunta"
              label="Pergunta"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sigfoco-select-ativo
            :cols="3"
            v-model="form.filters.ativo"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarFaqs()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Incluir"
              icon="mdi-plus"
              @click="openDialogManterFaq()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        show-expand
        :expanded.sync="expanded"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.pergunta`]="{ item }">
          <p class="text-wrap" style="max-width: 50vw;">{{ item.pergunta }}</p>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="blue-grey lighten-3">
              <p class="ml-4 text-wrap" style="max-width: 70vw;">{{ item.resposta }}</p>
            </td>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            text="Visualizar"
            icon="mdi-eye-outline"
            small
            @click="openDialogVisualizarFaq(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Editar"
            icon="mdi-pencil"
            small
            @click="openDialogManterFaq(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.ativo ? 'var(--primary-button-color)' : 'silver'}`"
            small
            @click="alterarStatusFaq(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <VisualizarFaqDialog
      :visible="dialogVisualizarFaq.visible"
      :content="dialogVisualizarFaq.content"
      @onClose="dialogVisualizarFaq.close()"
    ></VisualizarFaqDialog>
    <CadastrarEditarFaqDialog
      :edit="dialogManterFaq.edit"
      :visible="dialogManterFaq.visible"
      :content="dialogManterFaq.content"
      @onClose="dialogManterFaq.close()"
      @onSave="buscarFaqs()"
    ></CadastrarEditarFaqDialog>
  </div>
</template>

<script>
import { Faq } from "~/commons/classes/faq";
import { Dialog } from "~/commons/classes/dialog";
import ManterFaqService from "~/services/manter-faq.service"
import VisualizarFaqDialog from "./dialogs/VisualizarFaqDialog.vue";
import CadastrarEditarFaqDialog from "./dialogs/CadastrarEditarFaqDialog.vue";

export default {
  name: "ManterFaqsView",
  mixins: [ManterFaqService],
  components: {
    VisualizarFaqDialog,
    CadastrarEditarFaqDialog
  },
  data: () => ({
    expanded: [],
    dialogManterFaq: Dialog.Build(),
    dialogVisualizarFaq: Dialog.Build(),
    form:{
      filters: {
        nome: null,
        origem: null,
        ativo: null,
      },
    },
    table: {
      headers: [
        { text: "Pergunta", align: "start", value: "pergunta" },
        { text: "Resposta", align: "center", value: "data-table-expand" },
        { text: "Situação", align: "center", value: "ativo" },
        { text: "Ação", align: "center", value: "acoes", sortable: false },
      ],
      itens: [],
    }
  }),
  methods: {
    buscarFaqs() {
      this.$buscarFaqs({ params: this.form.filters }).then(
        ({ data }) => this.table.itens = data.itens
      )
    },
    resetForm() {
      this.$resetForm();
      this.expanded = [];
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
    openDialogManterFaq(faq) {
      faq
        ? this.$visualizarFaq(faq.id).then(
          ({ data }) => this.dialogManterFaq.open(new Faq(data.resposta), true))
        : this.dialogManterFaq.open(Faq.Build());
    },
    openDialogVisualizarFaq(faq) {
      this.$visualizarFaq(faq.id).then(
        ({ data }) => this.dialogVisualizarFaq.open(new Faq(data.resposta))
      );
    },
    excluirFaq(faq) {
      this.$swal({
        text: `Deseja confirmar a exclusão da faq?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$excluirFaq(faq.id).then(
          ({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarFaqs();
          });
      });
    },
    alterarStatusFaq(faq) {
      this.$swal({
        text: `Deseja ${ faq.ativo ? "inativar" : "ativar" } a pergunta e resposta do FAQ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarFaq(faq.id).then(
          ({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarFaqs();
          });
      });
    },
  },
}
</script>